import script from "./pieChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./pieChart.vue?vue&type=script&setup=true&lang=ts"

import "./pieChart.vue?vue&type=style&index=0&id=21b66b8f&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21b66b8f"]])

export default __exports__